import angular from 'angular'
import routers from './routers.js'
import dataCollectionCtrl from './dataCollectionCtrl'

export default angular
  .module('declaration.vatDeclarationSurcharges.dataCollection', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
      })
    },
  ])
  .controller('dataCollectionCtrl', dataCollectionCtrl).name



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/dataCollection/index.js